import {use} from 'react'
import {UserNameDisplayContext} from './UserNameDisplayContext'

export interface ProfileReferenceProps {
  login: string
  profileName?: string | null
  isAgent: boolean
}

export function ProfileReference({login, profileName, isAgent}: ProfileReferenceProps) {
  const displayMode = use(UserNameDisplayContext)

  if (isAgent) {
    return <>{login}</>
  }

  if (displayMode === 'name_handle' && profileName?.trim()) {
    return (
      <>
        {profileName} ({login})
      </>
    )
  }

  // displayMode === 'handle'
  return <>{login}</>
}

try{ ProfileReference.displayName ||= 'ProfileReference' } catch {}